import { createModule } from "saga-slice";
import categoryService from "../services/categoryService";
import { call, put } from "redux-saga/effects";

const initialState = {
    list: [],
    loading: false,
    error: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 5, // Size of each page

};

const categorySlice = createModule({

    name: 'categories',
    initialState,
    reducers: {
        list: (state) => {
            state.loading = true;
        },
        create: (state) => {
            state.loading = true;
        },
        update: (state) => {
            state.loading = true;
        },
        delete: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.list = payload.body;
            // state.totalElements = payload.body.totalElements; // Assuming totalElements is in payload
            // state.totalPages = payload.body.totalPages; // Assuming totalPages is in payload
            // state.pageNumber = payload.body.pageNumber;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },
    },
    sagas: (A) => ({
        *[A.list]() {
            try {
                const {data} = yield call(categoryService.list);
                yield put(A.fetchedData(data));
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.create]({ payload }) {
            try {
                const {data} = yield call(categoryService.create, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess,data.body);
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        
        *[A.update]({ payload }) {
            try {
                const {data} = yield call(categoryService.update, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess(data.body));
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.delete]({ payload }) {
            try {
                const {data} = yield call(categoryService.delete, payload);
                yield put(A.finishFetching());
                yield put(A.list());
            } catch (error) {
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    }),
});

export default categorySlice;
export const categoryActions = categorySlice.actions;


